<fui-autocomplete-option [field]="field" [key]="key" *ngFor="let option of filteredOptions" [option]="option"></fui-autocomplete-option>
